import React from "react";
import { Route, Switch } from "react-router-dom";
import { ChangesPage, LoginPage } from "pages";
import ProtectedRoutes from "routes/ProtectedRoutes";

export const Routes: React.FC = () => {
  return (
    <>
      <Switch>
        <Route path="/login" component={LoginPage} />
        <Route path="/changes" component={ChangesPage} />
        <ProtectedRoutes />
      </Switch>
    </>
  );
};

export default Routes;
